
export default {
    setVagaBeneficio(state, data) {
        state.vagaBeneficio = data
    },
    setVagasBeneficios(state, data) {
        state.vagasBeneficios = data
    },
}